export default function BrandMark({ size = 36, dark = "#1A1A1A", accent = "#B85540", className = "" }) {
  return (
    <svg
      viewBox="0 0 60 64"
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      {/* Bar 1 (shortest, dark) */}
      <polygon points="8,38 16,30 16,64 8,64" fill={dark} />
      {/* Bar 2 (medium, dark) */}
      <polygon points="22,24 30,16 30,64 22,64" fill={dark} />
      {/* Bar 3 (tallest, accent) */}
      <polygon points="36,10 44,2 44,64 36,64" fill={accent} />
    </svg>
  );
}
